// extracted by mini-css-extract-plugin
export default {"wrapper":"security-note-module__wrapper--uTS"};